<template>
  <div v-if="rows > perPage" class="matchingPagination">
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      class="mt-4"
    >
      <template #first-text>
        <button class="btnPagination">
          <img
            :src="require('@/assets/svg/double-back.svg')"
            alt=""
            width="14px"
            height="14px"
          />
        </button>
      </template>
      <template #prev-text>
        <button class="btnPagination">
          <img
            :src="require('@/assets/svg/back.svg')"
            alt=""
            width="14px"
            height="14px"
          />
        </button>
      </template>
      <template #next-text>
        <button class="btnPagination">
          <img
            :src="require('@/assets/svg/pagging-next.svg')"
            alt=""
            width="14px"
            height="14px"
          />
        </button>
      </template>
      <template #last-text>
        <button class="btnPagination">
          <img
            :src="require('@/assets/svg/double-next.svg')"
            alt=""
            width="14px"
            height="14px"
          />
        </button>
      </template>
      <template #ellipsis-text>
        <b-spinner small type="grow"></b-spinner>
        <b-spinner small type="grow"></b-spinner>
        <b-spinner small type="grow"></b-spinner>
      </template>
      <template #page="{ page, active }">
        <span v-if="active">
          {{ page }}
        </span>
        <i v-else>{{ page }}</i>
      </template>
    </b-pagination>
  </div>
</template>

<script>
export default {
  name: "PaginationMatching",
  props: {
    rows: Number,
    page: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.matchingPagination {
  display: flex;
  justify-content: center;
  padding-top: 40px;

  ul {
    display: flex;
    gap: 8px;
  }

  .btnPagination {
    height: 32px;
    width: 32px;
    border: 0px;
    border-radius: 50%;
    background-color: transparent;
    cursor: pointer;
  }
}
</style>
